import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/dropdown.scss';

/** Dropdown component
 *
 * Generates a dropdown component with its <option> elements provided as children.
 *
 * @example
 * <Dropdown
 *      title={ 'Title above the dropdown' }
 *      id={ 'some-unique-identifier' }
 *      onChange={ theOnChangeFunction() }
 *      value={ number of the selected option }
 *      classes={ { optionalClasses } }
 * >
 *      <option value="a1">a1</option>
 *      <option value="a2">a2</option>
 * </Dropdown>
 */
export default class Dropdown extends Component {
    render() {
        const { title, id, onChange, value, classes, children } = this.props;

        return <div className={ `${style.dropDown} ${classes.root}` }>
            { title
                ? <span>{ title }</span>
                : null
            }
            <select
                className={ `${style.optionSelection} ${classes.optionSelection}` }
                id={ id }
                onChange={ event => {
                    onChange(event);
                } }
                value={ value }
            >
                { children }
            </select>
        </div>;
    }
}

Dropdown.propTypes = {
    title: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.number,
    classes: PropTypes.shape({
        root: PropTypes.string,
        optionSelection: PropTypes.string
    })
};

Dropdown.defaultProps = {
    title: '',
    id: 'default-id',
    onChange: null,
    value: 0,
    classes: {
        root: '',
        optionSelection: ''
    }
};
